/* Product page, phone: dots under the swipe photos and the sticky add-to-bag bar (Figma, Bride tee product page). */
(function () {
  function dots() {
    var list = document.querySelector('.m4y-pdp .product__media-list');
    if (!list || list.dataset.m4yDots) return;
    var items = list.querySelectorAll('.product__media-item');
    if (items.length < 2) return;
    list.dataset.m4yDots = '1';
    var wrap = document.createElement('div');
    wrap.className = 'm4y-dots';
    wrap.setAttribute('aria-hidden', 'true');
    items.forEach(function () { wrap.appendChild(document.createElement('span')); });
    list.parentElement.appendChild(wrap);
    function paint() {
      var idx = Math.round(list.scrollLeft / (items[0].offsetWidth || 1));
      wrap.querySelectorAll('span').forEach(function (d, n) { d.classList.toggle('is-on', n === idx); });
    }
    list.addEventListener('scroll', paint, { passive: true });
    paint();
  }

  function sticky() {
    var bar = document.querySelector('[data-m4y-stickyatc]');
    var real = document.querySelector('.product-form__submit');
    if (!bar || !real) return;
    var sub = bar.querySelector('[data-m4y-stickyatc-sub]');
    var btn = bar.querySelector('button');
    function sync() {
      var form = real.closest('product-info, .product') || document;
      var picked = [].map.call(form.querySelectorAll('.product-form__input input[type=radio]:checked'), function (i) { return i.value; }).join(' / ');
      var price = form.querySelector('.price-item--sale, .price-item--regular');
      var priceText = price ? price.textContent.trim() : '';
      sub.textContent = [picked, priceText].filter(Boolean).join(', ');
      btn.disabled = real.disabled;
    }
    new IntersectionObserver(function (e) {
      var away = !e[0].isIntersecting && e[0].boundingClientRect.top < 0;
      bar.hidden = !away;
      document.body.classList.toggle('m4y-sticky-on', away);
      if (away) sync();
    }).observe(real);
    btn.addEventListener('click', function () { real.click(); });
  }

  dots();
  sticky();
})();
